import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import Footer from "@/features/LandingPage/Footer";

function Policy() {
  return (
    <div className="h-screen bg-white py-4">
      <Head>
        <title>Fundview | Security Measure</title>
      </Head>
      <section id="get-started-today" aria-label="Request Demo" className="relative h-full overflow-hidden">
        <div className="relative mt-10 sm:mx-20">
          <div className="mb-10 flex items-center">
            <Image className="h-8 w-auto" width={300} height={200} src="/fv_logo.png" alt="Fundview" />
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-2xl lg:text-2xl">
            Google API Disclosure for Fundview
          </h2>
          <p className="pt-5 text-lg text-gray-600">
            Fundview client apps use Google APIs when you use your Google account to sign in and use Fundview apps and
            services.
          </p>
          <p className="pt-5 text-lg text-gray-600">
            Fundview apps’s use and transfer to any other app of information received from Google APIs will adhere to{" "}
            <a
              className="text-indigo-600 hover:underline"
              href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
            >
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements.
          </p>
          <p className="pt-5 text-lg text-gray-600">
            You can also see our privacy policy{" "}
            <Link href="/policy" className="text-indigo-600 hover:underline">
              here
            </Link>
            .
          </p>
          <p className="pt-5 text-lg text-gray-600">
            If you have any questions, clarifications or concerns, please contact us at{" "}
            <a className="text-indigo-600 hover:underline" href="mailto:support@fundview.com">
              support@fundview.com
            </a>
            .
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Policy;
